import React from 'react';
import { useGallery } from '../../context/GalleryContext';
import { NavTree } from './NavTree';
import { useActiveSectionPath } from './useActiveSectionPath';

// Desktop left sidebar (≥ lg). Below lg the nav lives in the MobileNavDrawer instead.
export const Sidebar = () => {
    const { navTree } = useGallery();
    const activePath = useActiveSectionPath();

    return (
        <nav
            aria-label="Sections"
            className="hidden shrink-0 basis-sidebar px-8 pt-9 pb-8 lg:block"
        >
            <NavTree nodes={navTree} activePath={activePath} />
        </nav>
    );
};
